import { ConstructorResultsSdkResponseObject, PopularSearchesData, SearchOptionLinksObject } from 'types/SearchProvider'
import { addStoreLocaleByCookie } from 'lib/storeLocale/client'

export const transformConstructorRecommendationsResults = (
  recommendationsResponse: ReadonlyArray<ConstructorResultsSdkResponseObject<PopularSearchesData>>
): ReadonlyArray<SearchOptionLinksObject> => {
  return (
    (recommendationsResponse || []).map(({ value }) => ({
      label: value?.toLowerCase(),
      link: addStoreLocaleByCookie(`/all?query=${encodeURIComponent(value)}`),
    })) || []
  )
}
